module.exports = __webpack_public_path__ + "static/media/iStock-829469376.ca1ce2b3.jpg";